import {
  Control,
  Field,
  IconName,
  IconVariant,
  PopoverPlacement,
  PopoverTrigger,
  RadioBox
} from "@quortex/front-common"
import { Controller, useFormContext } from "react-hook-form"
import {
  type ContentSteeringServerFormType,
  type ContentSteeringServerType,
  serverOptions
} from "@/App/play/App/Main/Settings/ContentSteering/helpers"

type Props = {
  onChangeServer: (value: ContentSteeringServerFormType["server"]) => void
}

const ContentSteeringServerField = ({ onChangeServer }: Props) => {
  const form = useFormContext<ContentSteeringServerFormType>()

  return (
    <Field
      className="mb-lg"
      label="Content steering server"
      name="server"
      popoverProps={{
        description:
          "Choose how your streams are directed to viewers. Connect Switch and Play for seamless steering or use Quortex Play with your own third‑party content steering server.",
        icon: { name: IconName.INFO, type: IconVariant.REGULAR },
        placement: PopoverPlacement.RIGHT,
        title: "Content steering server",
        trigger: PopoverTrigger.CLICK
      }}
    >
      {name => (
        <div className="flex w-full gap-sm">
          {serverOptions.map(({ value, label, subtitle }) => (
            <Controller
              key={value}
              control={form.control}
              name={name}
              render={({ field }) => (
                <Control
                  {...field}
                  as={RadioBox}
                  checked={field.value === value}
                  className="w-full max-w-[16rem]"
                  label={label}
                  subtitle={subtitle}
                  value={value}
                  onChange={e => {
                    onChangeServer(e.target.value as ContentSteeringServerType)
                  }}
                />
              )}
            />
          ))}
        </div>
      )}
    </Field>
  )
}

export default ContentSteeringServerField
